import HttpService from '../../../services/http/httpService';
import config from '../../../config';

// Servicio del modulo de accesos (lista de usuarios autorizados / whitelist).
// Extiende HttpService, que ya inyecta el Bearer token y el userEmail en cada
// peticion. Todos los endpoints requieren usuario admin (verifyAdminOnly en el
// backend) y el query param headquarter (obligatorio aunque la lista sea global;
// se persiste siempre en CEDESCA).
//
// Convencion de headquarter (CEDESCA|CNTEC):
//  - GET / DELETE -> en query params
//  - POST         -> en query params Y en el body (lo valida el schema)
//
// Se usa silent: true en todos los metodos para que el error llegue al hook de
// React Query (mutacion/consulta) y la pantalla muestre el mensaje del backend
// en vez del toast global generico.
class AccesosService extends HttpService {
  // GET /accesos?headquarter=... -> { data: [{ id, email, nombre, activo, fechaAlta, creadoPor }] }
  // Devuelve activos e inactivos (activo:false = revocado).
  async listarAccesos({ headquarter }) {
    return this.get('accesos', { params: { headquarter }, silent: true });
  }

  // POST /accesos?headquarter=... body { email, nombre, headquarter } -> { ok: true }
  // Upsert: si el email ya existe (aunque estuviera revocado) lo reactiva y
  // actualiza el nombre. No hay error por duplicado.
  async crearAcceso({ headquarter, email, nombre }) {
    return this.post(
      'accesos',
      { headquarter, email, ...(nombre != null ? { nombre } : {}) },
      { params: { headquarter }, silent: true },
    );
  }

  // DELETE /accesos/:id?headquarter=... -> { ok: true } | 404 { error: 'No encontrado' }
  // Soft-delete (activo=0). Reactivable volviendo a hacer POST con el mismo email.
  async revocarAcceso({ headquarter, id }) {
    return this.delete(`accesos/${id}`, { params: { headquarter }, silent: true });
  }
}

const accesosService = new AccesosService(config.REACT_APP_NODE_API);
export default accesosService;
